var _rect, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoldenstar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 115,
    viewBox: "0 0 75 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 115,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -354,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.326 22.9074H85.6545L69.0139 -26.3114L52.3733 22.9074H-1.29858L42.0608 53.3761L25.4202 102.595L69.0139 72.1261L112.373 102.595L95.7327 53.3761L139.326 22.9074Z",
    fill: "#F39B17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.269 16.5787L111.644 -10.14L87.0348 6.73499L90.5504 16.5787H102.269ZM59.3785 86.1881L68.9879 114.313L78.5973 86.1881L68.9879 79.6256L59.3785 86.1881ZM112.816 49.3912L103.91 55.485L107.66 66.735H137.894L112.816 49.3912ZM50.941 6.73499L26.3317 -10.14L35.7067 16.5787H47.4254L50.941 6.73499ZM25.1598 49.3912L0.081665 66.735H30.316L34.066 55.485L25.1598 49.3912Z",
    fill: "#F39B17"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -353,
    y: 1,
    width: 427,
    height: 220,
    rx: 7,
    stroke: "#F39B17",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -354,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenstar);
export default "data:image/svg+xml,%3csvg width='75' height='115' viewBox='0 0 75 115' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='75' height='115' fill='%23F5F5F5'/%3e %3cg clip-path='url(%23clip0_3916_412046)'%3e %3crect x='-354' width='429' height='222' rx='8' fill='white'/%3e %3cg opacity='0.15'%3e %3cpath d='M139.326 22.9074H85.6545L69.0139 -26.3114L52.3733 22.9074H-1.29858L42.0608 53.3761L25.4202 102.595L69.0139 72.1261L112.373 102.595L95.7327 53.3761L139.326 22.9074Z' fill='%23F39B17'/%3e %3cpath d='M102.269 16.5787L111.644 -10.14L87.0348 6.73499L90.5504 16.5787H102.269ZM59.3785 86.1881L68.9879 114.313L78.5973 86.1881L68.9879 79.6256L59.3785 86.1881ZM112.816 49.3912L103.91 55.485L107.66 66.735H137.894L112.816 49.3912ZM50.941 6.73499L26.3317 -10.14L35.7067 16.5787H47.4254L50.941 6.73499ZM25.1598 49.3912L0.081665 66.735H30.316L34.066 55.485L25.1598 49.3912Z' fill='%23F39B17'/%3e %3c/g%3e %3c/g%3e %3crect x='-353' y='1' width='427' height='220' rx='7' stroke='%23F39B17' stroke-width='2'/%3e %3cdefs%3e %3cclipPath id='clip0_3916_412046'%3e %3crect x='-354' width='429' height='222' rx='8' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };